(function () {

  const teaser_card_slider_list = document.querySelectorAll('.js_teaser_card_slider')

  window.dataLayer = window.dataLayer || [];

  for (let i = 0; i < teaser_card_slider_list.length; i++) {
    const slider = teaser_card_slider_list[i]
    initTeaserCardSlider(slider)
  }

  function initTeaserCardSlider (slider) {
    const sliderWrapEl = slider.closest('.teaser-card-slider-sec')
    const swiperPagination = sliderWrapEl.querySelector('.swiper-pagination')
    const swiperButtonNext = sliderWrapEl.querySelector('.swiper-button-next')
    const swiperButtonPrev = sliderWrapEl.querySelector('.swiper-button-prev')

    let userHasInteracted = false;

    let sliderOptions = {

      spaceBetween: 40,
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 768px
        767: {
          slidesPerView: 2,
          spaceBetween: 30,
          centeredSlides: false,
        },
        // when window width is >= 1200px
        1200: {
          slidesPerView: 3,
          spaceBetween: 30,
          // centeredSlides: true,
          centeredSlides: false,
        }
      },
      pagination: {
        el: swiperPagination,
        clickable: true,
        dynamicBullets: false,
      },
      navigation: {
        nextEl: swiperButtonNext,
        prevEl: swiperButtonPrev,
      },
      on: {
        touchEnd: function () {
          userHasInteracted = true;
        },
        navigationNext: function () {
          userHasInteracted = true;
        },
        navigationPrev: function () {
          userHasInteracted = true;
        },
        slideChangeTransitionEnd: function () {
          if (userHasInteracted) {
            const gtmEvent = {
              trigger: 'click on recipe slider',
              event_id: '1.2',
              event: 'slider_navigation',
              event_campaign: 'general',
              content_type: 'recipe slider',
              category: 'recipes',
              market: window.getMarketFromUrl()
            };

            window.dataLayer.push(gtmEvent);
          }
        }
      }
    }

    // Override from theme
    // if (window.productSliderV1Override) {
    //   sliderOptions = window.productSliderV1Override(slider)
    // }

    new Swiper(slider, sliderOptions)

    const recipeLinks = slider.querySelectorAll('.js_teaser_card_slider .js_teaser-card__link');
    recipeLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        console.log(link)

        const recipeName = this.getAttribute('data-recipe-name');
        const linkUrl = this.getAttribute('data-link-url');

        const gtmEvent = {
          trigger: 'click on links on recipe sliders',
          event_id: '1.4',
          event: 'select_content',
          link_url: linkUrl,
          event_campaign: 'general',
          content_type: 'recipe slider',
          content_id: recipeName,
          category: 'recipes',
          market: window.getMarketFromUrl()
        };

        // console.log('Recipe Link Click: ', gtmEvent);
        window.dataLayer.push(gtmEvent);
      });
    });

  }

})()
